import React, { useState } from "react";
import {
  Container,
  ContainerView,
  TitlePage,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { formatter } from "../../utils/hepler";
import { AffiliateComponent } from "../../components/AffiliateComponent";
import { getBonusDetail, getEverflow, getSSOMLM } from "../../services/app";
import { useEffect } from "react";
import environment from "../../environment";
export const defaultValue = {
  mlmUrl: "",
  summary: {
    total_click: 0,
    ctr: 0,
  },
  affiliate: {
    referral_code: "",
    link: "",
  },
  left_count: 0,
  right_count: 0,
  downline: 0,
  frontline: 0,
  binary_bonus: 0,
  direct_sales_commission: 0,
  my_team_commission: 0,
  team_affiliate_rank: "0",
  team_affiliate_need_amount: "0",
  line_rank: "",
  line_need_amount: "0",
  next_line: "",
  totalCommission: 0,
  // period_binary_bonus: 0,
  // period_direct_sales_commission: 0,
  // period_my_team_commission: 0,
};

export const Affiliate = () => {
  const { T, language, setLoading, user, convertToCurrency } = useApp();
  const [data, setData] = useState();
  useEffect(() => {
    setLoading(true);
    if(Number(user?.is_agree_policy) === 0 && !user.mlm_id) {
      setLoading(false);
      return;
    }
    Promise.all([getBonusDetail(), getSSOMLM(), getEverflow()])
      .then((response) => {
        setLoading(false);
        const dataBonus = response[0]?.data?.data;
        const dataUrl = environment.MLM_LOGIN_URL;
        const dataEverFlow = response[2]?.data?.data;
        let originUrlLinkMLM = dataUrl;
        let originUrlLinkMLM1 = dataUrl;
        let originUrlLinkMLM2 = dataUrl;
        let originUrlLinkMLM3 = dataUrl;
        originUrlLinkMLM2 = originUrlLinkMLM2.replace(`/en-US`, `/en-US/network/view-network`);
        originUrlLinkMLM3 = originUrlLinkMLM3.replace(`/en-US`, `/en-US/network/downline`);
        if (["ja", "ko"].includes(language)) {
          originUrlLinkMLM = originUrlLinkMLM.replace(`/en-US`, `/${language}`);
          originUrlLinkMLM1 = originUrlLinkMLM1.replace(`/en-US`, `/${language}`);
          originUrlLinkMLM2 = originUrlLinkMLM2.replace(`/en-US`, `/${language}/network/view-network`);
          originUrlLinkMLM3 = originUrlLinkMLM3.replace(`/en-US`, `/${language}/network/downline`);
        }
        let totalCommission = dataBonus?.total_commission;
        totalCommission = isNaN(totalCommission) ? 0 : totalCommission;
        totalCommission = formatter(totalCommission);
        setData({
          mlmUrl: originUrlLinkMLM,
          mlmUrl1: originUrlLinkMLM1,
          mlmUrl2: originUrlLinkMLM2,
          mlmUrl3: originUrlLinkMLM3,
          ...dataEverFlow,
          ...dataBonus,
          totalCommission,
        });
      })
      .catch(() => {
        setData(defaultValue);
        setLoading(false);
      });
  }, [user]);

  return (
    <Container>
      <ContainerView>
        {(user?.is_agree_policy == 1) && (
          <div className="flex justify-between items-center">
            <TitlePage>{T("Affiliate")}</TitlePage>
          </div>
        )}

        <AffiliateComponent isPage data={data} />
      </ContainerView>
    </Container>
  );
};
